import { render, staticRenderFns } from "./PlatformMenuCopy.vue?vue&type=template&id=387fe618"
import script from "./PlatformMenuCopy.vue?vue&type=script&lang=js"
export * from "./PlatformMenuCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports